(() => {
  const containerSelector = '#hubspot-messages-iframe-container';
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  let container;
  let containerObserver;
  let frameRequest;

  const updatePositionState = () => {
    frameRequest = undefined;

    const nextContainer = document.querySelector(containerSelector);
    if (nextContainer !== container) {
      containerObserver?.disconnect();
      container = nextContainer;

      if (container) {
        containerObserver = new MutationObserver(scheduleUpdate);
        containerObserver.observe(container, {
          attributes: true,
          attributeFilter: ['style'],
        });
      }
    }

    if (!container) return;

    const { width, height } = container.getBoundingClientRect();
    const isMobileLauncher = mobileViewport.matches
      && width > 0
      && width <= 320
      && height > 0
      && height <= 140;

    container.classList.toggle('tm-hubspot-mobile-launcher', isMobileLauncher);
  };

  function scheduleUpdate() {
    if (frameRequest) return;
    frameRequest = window.requestAnimationFrame(updatePositionState);
  }

  const pageObserver = new MutationObserver(scheduleUpdate);
  pageObserver.observe(document.body, { childList: true, subtree: true });

  mobileViewport.addEventListener('change', scheduleUpdate);
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  scheduleUpdate();
})();
